<template>
    <vx-card title="Places">
        <div id="viewPlaceLoadingDiv" class="vs-con-loading__container">
            <vs-table :sst="true" @search="handleSearch" @change-page="handleChangePage" @sort="handleSort"
                v-model="selected" :data="places">

                <template slot="header">
                    <div class="flex flex-wrap items-center w-full">
                        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus-circle"
                            @click="addPlace">Add a Place</vs-button>

                        <treeselect placeholder="Place Type" style="width: 200px;" @input="searchPlaces" class="ml-4"
                            v-model="selected_place_type" :multiple="false" :options="place_types" />

                        <vs-input style="width: 200px;" class="ml-4" placeholder="Name" v-model="selected_place_name" />

                        <vs-input style="width: 200px;" class="ml-4" placeholder="Location"
                            v-model="selected_place_location" />

                        <vs-button color="primary" class="ml-4" type="filled" icon-pack="feather" icon="icon-search"
                            @click="searchPlaces">Search</vs-button>
                    </div>
                </template>

                <template slot="thead">
                    <vs-th sort-key="id">Id</vs-th>
                    <vs-th sort-key="type">Type</vs-th>
                    <vs-th style="width: 20%;">Name</vs-th>
                    <vs-th style="width: 40%;">Location</vs-th>
                    <vs-th>Image</vs-th>
                    <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].id">
                            {{ data[indextr].id }}
                        </vs-td>
                        <vs-td :data="data[indextr].type">
                            {{ data[indextr].type }}
                        </vs-td>
                        <vs-td style="width: 20%;" :data="data[indextr].name">
                            {{ data[indextr].name.en ? data[indextr].name.en : '' }}
                        </vs-td>
                        <vs-td style="width: 40%;" :data="data[indextr].location">
                            {{ data[indextr].location && data[indextr].location.place_name ?
                                data[indextr].location.place_name : '' }}
                        </vs-td>
                        <vs-td :data="data[indextr].images">
                            <img v-if="data[indextr].images.length" width="50" :src="data[indextr].images[0].file_path">
                        </vs-td>
                        <vs-td>
                            <vs-row>
                                <vs-button @click="editPlace(data[indextr])" class="mr-2" color="primary" type="border"
                                    icon-pack="feather" icon="icon-edit"></vs-button>
                                <vs-button @click="deletePlace(data[indextr])" color="danger" type="filled"
                                    icon-pack="feather" icon="icon-trash"></vs-button>
                            </vs-row>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <div class="vx-row justify-center mt-base">
                <div class="vx-col">
                    <h5 class="mt-4 mb-4 ">Total pages : {{this.totalPage}}
                    </h5>
                    <!-- <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination> -->
                </div>
                </div>  
            <div class="vx-row justify-center mt-base">
                <div class="vx-col">
                    <p class="mt-4 mb-4">Jump to the page no:
                    </p>
                    <!-- <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination> -->
                </div>
                <div class="vx-col mb-2">
                    <vs-input style="width: 100px;" class="ml-4" type="number" placeholder="Page no" v-model="pageJump" />

                </div>
                <div class="vx-col mb-2">
                    <vs-button @click="$event=>jumpToPage()" class="mr-2" color="primary" type="border"
                        icon-pack="feather" icon="icon-arrow-right"></vs-button>

                </div>
            </div>
           

        </div>
        <div class="justify-center vx-row  ">
            <pagination :records="totalPage" v-model="currentPage" :per-page="10" @paginate="callback">
            </pagination>
        </div>

        
    </vx-card>
</template>

<script>
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import modulePlaceManagement from '@/store/place-management/modulePlaceManagement.js'
import Pagination from 'vue-pagination-2';

export default {
    components: {
        vSelect,
        Treeselect,
        Pagination
    },
    data() {
        return {
            page: 1,
            pageJump: 1,
            selected: [],
            key: null,
            active: null,
            search: null,
            totalPage: 1,
            currentPage: 1,
            places: [],
            deletePlaceData: null,
            selected_place_name: null,
            selected_place_location: null,
            selected_place_type: "all",
            place_types: [
                { id: 'all', label: 'All' },
                { id: 'place', label: 'Place' },
                { id: 'event', label: 'Event' },
                { id: 'tip', label: 'Tip' },
            ],
        }
    },
    watch: {
        currentPage(val) {
            this.searchPlaces()
            // alert(val);
            localStorage.setItem('selectedPage', val);
        }
    },
    mounted() {
        this.places = this.$store.state.placeManagement.places
    },
    methods: {
        jumpToPage() {
            if(parseInt(this.pageJump) < this.totalPage) {
                console.log(this.pageJump);
            this.currentPage = parseInt(this.pageJump);
            } else {
                this.$vs.notify({
                    title: 'Warning',
                    text:  `Page number should be below the count of total page number ${this.totalPage}`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                  })
            }
          
        },
        callback (currentPage) {
            console.log(`Page ${currentPage} was selected. Do something about it`);
        },
        changePlaceType(place) {


        },
        deletePlace(place) {
            this.deletePlaceData = place;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure to delete this place data ?',
                accept: this.acceptDeletePlace
            })
        },
        acceptDeletePlace() {
            this.$vs.loading();

            this.$store.dispatch("placeManagement/deletePlace", { id: this.deletePlaceData.id })
                .then(res => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: "Success.",
                        text: "Place deleted successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });
                })
                .catch(err => {
                    this.$vs.loading.close()
                })
        },
        editPlace(place) {
            this.$router.push("/places/" + place.id).catch(() => { })
        },
        addPlace() {
            this.$router.push("/places/add").catch(() => { })
        },
        handleSearch(searching) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = searching
                this.searchPlaces()
            }, 2000);
        },
        handleChangePage(currentPage) {
            // this.searchUser()
        },
        handleSort(key, active) {
            if (key) {
                this.key = key
                this.active = active
                this.searchPlaces()
            }
        },
        async searchPlaces() {
            var self = this
            this.$vs.loading({
                container: '#viewPlaceLoadingDiv',
                scale: 0.6
            })

            let data = {
                name: this.selected_place_name,
                location: this.selected_place_location,
                sort: this.key,
                sort_key: this.active,
                page: this.currentPage,
                place_type: this.selected_place_type,
            }

            await this.$store.dispatch("placeManagement/viewPlace", data)
                .then(res => {
                    this.totalPage = res.data.last_page
                    this.$vs.loading.close('#viewPlaceLoadingDiv > .con-vs-loading')
                })
                .catch(err => {
                    this.$vs.loading.close('#viewPlaceLoadingDiv > .con-vs-loading')
                })

            this.places = this.$store.state.placeManagement.places
        },
        async viewPlaces() {
            var self = this

            await this.$store.dispatch("placeManagement/viewPlace", { page: this.currentPage })
                .then(res => {
                    this.totalPage = res.data.last_page
                })

            this.places = this.$store.state.placeManagement.places
        },
    },
    async created() {
        if (!modulePlaceManagement.isRegistered) {
            this.$store.registerModule('placeManagement', modulePlaceManagement)
            modulePlaceManagement.isRegistered = true
        }

        await this.viewPlaces()
        if(localStorage.getItem('selectedPage') != null) {
            console.log(localStorage.getItem('selectedPage'));
            this.currentPage = parseInt(localStorage.getItem('selectedPage'));
        }
    },
}
</script>
<style type="text/css">
.VuePagination__count.VuePagination__count {
    visibility: hidden;
}

ul.VuePagination__pagination.pagination.VuePagination__pagination {
    background-color: #f0f0f0;
    border-radius: 50px;
    padding: 10px;
    display: flex;
}

.VuePagination__pagination-item.page-item.active {
    background-color: orange;
    color: white;
    border-radius: 10px;
}

.VuePagination__pagination-item.page-item {
    padding: 10px;
}

.page-link {
    color: orange;
    font-weight: 600;
}

.page-link.active {
    color: white;
    font-weight: 600;
}

.VuePagination__pagination-item.page-item::marker {
    visibility: hidden;
}

::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}

.vs-con-textarea {
    height: 400px;
}

.vs-textarea {
    height: 100%;
}

[v-cloak] {
    display: none;
}
</style>

